import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';


import DashboardIcon from '@material-ui/icons/Person';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import MenuIcon from '@material-ui/icons/Menu';
import { GitHub } from '@material-ui/icons';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { DiscordIcon, PatreonIcon } from '../../icons/Discord';
import { AppStoreCtx } from '../..';
import { Avatar, Box, Button, ButtonGroup, Container, Fab, Grid, Link, ListItem, ListItemIcon, ListItemText, Paper } from '@material-ui/core';
import { observer } from "mobx-react";
import { useQuery } from '@apollo/client';
import { ME } from '../../querys/q';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    Link as RouteLink,
    useLocation,
    useHistory
} from "react-router-dom";
import { AvatarMenu } from '../../UI/AvatarMenu';
import { InventoryItemList } from '../../UI/InventoryItemList';
import { Shop } from '../Shop/Shop';
import { Profile } from '../Profile/Profile';
import { AdminPageBase } from '../Admin/AdminPage';
import { Landingpage } from '../Landingpage/Landingpage';
import { CommandList } from '../CommandList/CommandList';
import { orange } from '@material-ui/core/colors';
import { Titlepacks } from '../Titlepacks/Titlepacks';
import { DashboardButtonBar } from './DasboardButtonBar';
import { Backgrounds } from '../Backgrounds/Backgrounds';


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="http://nycaria.de">
                Nycaria.de
      </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
            <RouteLink color="inherit" to="/impressum">
                Impressum
            </RouteLink>
            &nbsp;
            <RouteLink color="inherit" to="/privacy">
                Privacy
            </RouteLink>
        </Typography>
    );
}

const drawerWidth = 240;

export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarBottom: {
        zIndex: theme.zIndex.drawer + 5,
        bottom: 0,
        top: "auto",
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    bottomRight: {
        zIndex: theme.zIndex.drawer + 5,
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: orange[200],
    },
    fixedHeight: {
        height: 240,
    },
    noStyle: {
        textDecoration: "none",
        color: "inherit"
    }
}));

export const Dashboard: React.FC = observer(() => {
    const history = useHistory();
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const ctx = React.useContext(AppStoreCtx);

    const { data } = useQuery(ME);

    console.log(history)

    return (
        <Router>
        <div className={classes.root}>
            <CssBaseline />
            <AppBar style={{ width: !ctx.user ? "100%" : "", display: location.search.includes("hidetop=true") ? "none" : undefined }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    {ctx.user && <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon />
                    </IconButton>}
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                    <RouteLink className={classes.noStyle} to="/">
                        <Avatar src="https://media.discordapp.net/attachments/576435694785003520/682661860163846164/Comic3.png?width=658&height=466"/>
                    </RouteLink>
                    </Typography>
                    {(ctx.user && data) && <div style={{ fontSize: 8, marginRight: 16 }}>
                        ID: {data.me.id}<br />
                        Fluffs: {data.me.money}
                    </div>}
                    {ctx.user && <Typography color="inherit" noWrap>
                        Hallo {ctx.user.dcUser.username}!
                    </Typography>}
                    <DashboardButtonBar/>
                    <IconButton color="inherit">
                        {ctx.user ? <>
                            <AvatarMenu />
                        </>
                            : <Fab size="small" color="secondary" href={`https://discord.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_BOT_ID}&redirect_uri=${encodeURIComponent(location.protocol+"//"+location.host+"/auth")}&response_type=code&scope=identify%20guilds`}>
                                <DiscordIcon />
                            </Fab>}
                    </IconButton>

                </Toolbar>
            </AppBar>
            {ctx.user && <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <div>
                    <RouteLink className={classes.noStyle} to="/">
                        <ListItem button>
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="Profile" />
                        </ListItem>
                    </RouteLink>
                    <RouteLink className={classes.noStyle} to="/shop">
                        <ListItem button>
                            <ListItemIcon>
                                <ShoppingCartIcon />
                            </ListItemIcon>
                            <ListItemText primary="Shop" />
                        </ListItem>
                    </RouteLink>
                    <RouteLink className={classes.noStyle} to="/admin">
                        <ListItem button>
                            <ListItemText primary="ADMIN" />
                        </ListItem>
                    </RouteLink>
                    <ListItem button>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Users" />
                    </ListItem>
                </div>

            </Drawer>}
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                {/** APP */}
                <Switch>
                    <Route path="/auth">
                        <Child />
                    </Route>
                    <Route path="/commands">
                        <CommandList />
                    </Route>
                    <Route path="/titlepacks">
                        <Titlepacks />
                    </Route>
                    <Route path="/backgrounds">
                        <Backgrounds />
                    </Route>
                    <Route path="/impressum">
                        <div className="glass" style={{ margin: "auto", width: "60vw", padding: 16, marginTop: 32 }}>
                            <h1>Impressum</h1> 

                            <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
                            <p>Patrick Rau<br />
                            Swebengrund, 4f<br />
                            22159 Hamburg</p>

                            <h2>Kontakt</h2>
                            <p>Telefon: +49 151 53266461<br />
                            E-Mail: patrickrau95@gmail.com</p>

                            <h3>Haftung f&uuml;r Inhalte</h3> <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p> <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p> <h3>Haftung f&uuml;r Links</h3> <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p> <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p> <h3>Urheberrecht</h3> <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p> <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

                            <p>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>
                        </div>
                    </Route>
                    <Route path="/privacy">
                        <div className="glass" style={{ margin: "auto", width: "60vw", padding: 16, marginTop: 32 }}>
                            <h1>Privacy Policy</h1> 
                            <h3>Consent</h3>
                            <p>By using this website or by using Nycaria you consent to our Privacy Policy and agree to its terms</p>
                            <h3>Data Collection</h3>
                            <p>We don't show any ads or collect data by you using this site. We use the Browser internal localStorage to save your Session while logged in.</p>
                            <p>Nycaria on the other hand will collect data needed to run it's service. This include</p>
                            <ul>
                                <li>Discord User IDs</li>
                                <li>Guild IDs</li>
                                <li>Channel IDs</li>
                                <li>Message IDs</li>
                                <li>Role IDs</li>
                            </ul>
                            <p>The only logs we keep include: Exp gain, Fluff-Transactions between users and errors that where thrown while an command was used</p>
                            <p>You can contact us on our Support-Server where we can delete all your Nycaria related data and we can also ban you from using her, so your data wont be stored anymore</p>
                            <p>If you have any concerns about Nycaria, please contact our Support Team</p>
                        </div>
                    </Route>
                    {ctx.user && <><Route path="/shop">
                        <>
                            <Shop />
                        </>
                    </Route>
                    <Route path="/admin">
                        <Paper>
                            <AdminPageBase/>
                        </Paper>
                    </Route>
                    <Route path="/profile">
                        <Container>
                            <Grid style={{ marginTop: 16 }} container spacing={3}>
                                {/* Chart */}
                                <Grid item xs={8}>
                                    <Profile/>
                                </Grid>
                                <Grid item xs={4}>
                                    <InventoryItemList />
                                </Grid>
                            </Grid>
                        </Container>
                    </Route>
                    <Route exact path="/">
                        <Redirect to="/profile"/>
                    </Route>
                    </>}
                    
                    <Route exact path="/profile">
                        <Redirect to="/"/>
                    </Route>
                    <Route exact path="/" render={() =>
                        <>
                            {ctx.user ? <Redirect to="/user"/> : <Landingpage/>}
                        </>
                    }>
                    </Route>
                </Switch>
                {/** APP END */}
            </main>
            <div className={classes.bottomRight} style={{ top: "auto", bottom: 32, position: "absolute", textAlign: "center", width: "100%" }}>
                <div style={{ margin: "auto" }}>
                    <Copyright />     
                </div>
            </div>
            <div className={classes.bottomRight} style={{ top: "auto", bottom: 32, right: 0, position: "absolute", display: "flex", flexDirection: "column" }}>
                <IconButton color="inherit">
                    <Fab size="small" color="secondary" href={`https://github.com/14rau`}>
                        <GitHub />
                    </Fab>
                </IconButton> 
                <IconButton color="inherit">
                    <Fab size="small" color="secondary" href={`https://www.patreon.com/flauschoofer`}>
                        <PatreonIcon />
                    </Fab>
                </IconButton>
            </div>
        </div>
        </Router>
    );
})


const Child: React.FC = observer(() => {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get("code");
    const ctx = React.useContext(AppStoreCtx);

    const [isLoading, setIsLoading] = React.useState(true);

    const load = async () => {
        const res = await fetch(`${process.env.REACT_APP_AUTH_API || "/auth"}`, {
            method: "POST",
            body: JSON.stringify({ token }),
            headers: {
                "Content-Type": "application/json"
            }
        });

        const text = await res.text();
        ctx.setUser(text)
    }


    React.useEffect(() => {
        load().then(() => {
            setIsLoading(false);
        }).catch(() => alert("Sorry, an error occurred"));
    }, []);
    if (isLoading) return <div>LOADING</div>
    document.location.assign("/");
    return <Redirect to="/" />;
})
